import { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: string;
  badge?: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  meta?: ReactNode;
  action?: ReactNode;
}

export default function PageHeader({
  eyebrow,
  title,
  badge,
  subtitle,
  description,
  meta,
  action,
}: PageHeaderProps) {
  return (
    <section className="acc-page-header">
      <div className="acc-page-header__content">
        {eyebrow && <div className="acc-page-header__eyebrow">{eyebrow}</div>}
        <div className="acc-page-header__title-row">
          <h1 className="acc-page-header__title">{title}</h1>
          {badge}
        </div>
        {subtitle && <div className="acc-page-header__subtitle">{subtitle}</div>}
        {description && <div className="acc-page-header__description">{description}</div>}
        {meta && <div className="acc-page-header__meta">{meta}</div>}
      </div>

      {action && <div className="acc-page-header__actions">{action}</div>}
    </section>
  );
}
